/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { useEffect, useRef, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CreateInviteForm from '../../../../../components/invite/createForm';
import SelectLocationsComponent from '../../../../../components/invite/selectLocationsTable';
import { getUserDetails } from '../../../../../redux/slices/user/userDetails';
import { T, useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from '../../../../../routes/paths';
import { ACCESS_TYPE_SELECTED, ROLE_GUEST } from '../../../../../config/roles';
import { useLocales } from '../../../../../locales';
import { fetchSubscriptionData } from '../../../../../redux/slices/subscriptionManagement/subscriptionManagement';
import toast, { Toaster } from 'react-hot-toast';

const CreateInvite: React.FC = () => {
  const [cloudAccessType, setCloudAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  const [cockpitAccessType, setCockpitAccessType] =
    useState<any>(ACCESS_TYPE_SELECTED);
  const formComponentRef = useRef(null);
  const { t } = useTranslate();
  const [selectedLocations, setSelectedLocations] = useState<any>([]);
  const [selectedClouds, setSelectedClouds] = useState<any>([]);
  const dispatch = useDispatch();
  const { data } = useSelector((state: any) => state.subscriptionManagement);

  useEffect(() => {
    dispatch(getUserDetails() as any);
    if (!data) dispatch(fetchSubscriptionData() as any);
  }, [dispatch]);

  const [cockpitRole, setCockpitRole] = useState<any>(null);
  const [cloudRole, setCloudRole] = useState<any>(null);
  const navigate = useNavigate();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current && data) {
      // Check if the current URL contains "create"
      if (data?.available != null && data?.available <= 0) {
        toast.error(t('invite.createForm.cant_add_team_member'), {
          position: 'top-right'
        });
        setTimeout(() => {
          navigate(PATH_PAGE.team_management);
        }, 800);
      }
      // Set isFirstRender to false current the first render
      isFirstRender.current = false;
    }
  }, [data, history]);

  return (
    <Container>
      <div className="m-2" />
      <div className={'mb-2'}>
        <a
          onClick={() => {
            navigate(PATH_PAGE.team_management);
          }}
          className={'badge bg-secondary text-dark cursor-pointer'}
        >
          <T keyName={'back_button.back'}></T>
        </a>
      </div>
      <Toaster />
      <CreateInviteForm
        ref={formComponentRef}
        setCockpitRole={setCockpitRole}
        setCloudRole={setCloudRole}
        selectedLocations={selectedLocations}
        selectedClouds={selectedClouds}
        cloudAccessType={cloudAccessType}
        cockpitAccessType={cockpitAccessType}
      />
      <div className="m-2" />
      <SelectLocationsComponent
        cloudRole={cloudRole}
        cockpitRole={cockpitRole}
        cloudAccessType={cloudAccessType}
        setCloudAccessType={setCloudAccessType}
        cockpitAccessType={cockpitAccessType}
        setCockpitAccessType={setCockpitAccessType}
        setSelectedLocations={setSelectedLocations}
        setSelectedClouds={setSelectedClouds}
        selectedLocations={selectedLocations}
        selectedClouds={selectedClouds}
      />
      <div className="p-4 mt-2 card">
        <div className="d-flex justify-content-end">
          <Button
            onClick={() => {
              navigate(PATH_PAGE.team_management);
            }}
            size="sm"
            variant="secondary"
          >
            {t('buttons.cancel')}
          </Button>
          <div className="m-2" />
          <Button
            onClick={() => {
              if (formComponentRef.current)
                formComponentRef.current?.submitForm()();
            }}
            size="sm"
          >
            {cockpitRole !== ROLE_GUEST
              ? t('invite.createForm.send_invite')
              : t('invite.createForm.add_user')}
          </Button>
        </div>
      </div>
    </Container>
  );
};
export default CreateInvite;
